import React, { useRef, useContext, useEffect, useState } from "react";
import MyContext from "../../../context/MyContext";
import CharacterLoader from "../characterLoader";
import styled, { keyframes } from "styled-components";
import TickerContext from "../../../context/ticker";
import Draggable from "react-draggable";
import ProjectContext from "../../../context/ProjectContext";

function AnimatedText({
  StackStore,
  value,
  TickerPosition,
  resizeRef2,
  zInd,
  index,
  setAtoZ,
  resizeRef,
  MultiDrag,
  setMultiDrag,
  TickerStart,
  Call_ScreenShot,
  setCall_ScreenShot
}) {
  const {
    CanvasDisplay,
    setLayersData,
    LayersData,
    EditorZoom,
    clone,
    onePxEquivalent,
    seteditableObject,
  } = useContext(MyContext);
  const { slides, setslides } = useContext(ProjectContext);

  const locked = (e) => {
    e.target.previousSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const [Dragging, setDragging] = useState(false);

  const dragref = useRef(null);

  const { Click_TickerPosition, setTickerState } = useContext(TickerContext);

  const Unlock = async (obj) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === obj) {
        array[i].lock = false;
        array[i].layerlock = false;
        array[i].toolbar = true;
        array[i].showDiv = true;
      }
    }
    setLayersData(array);
  };

  const LockShow = (e) => {
    e.target.nextSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const TextClick = (key) => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        array[i].toolbar = true;
        array[i].Editable = true;
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
      }
    }
    setLayersData(array);
  };

  const CharRef = useRef(null);

  const [AnimationStyle, setAnimationStyle] = useState("");

  const [StoreData, setStoreData] = useState(null);

  const enterKeyFrame = (
    width,
    height,
    y,
    x,
    rotation,
    widthOnTimeline,
    check
  ) => {
    if (check) {
      let AzAngle;
      if (rotation > 180) {
        AzAngle = rotation - 360;
      } else {
        AzAngle = rotation;
      }

      let Angle;
      if (value.rotateAngle > 180) {
        Angle = value.rotateAngle - 360;
      } else {
        Angle = value.rotateAngle;
      }
      var aikVariable = calculateSecondsByWidth(widthOnTimeline);
      const AnimationFrames = keyframes`0%{ left:${value.x}px; top:${value.y}px; width:${value.width}px; height:${value.height}px; transform:rotate(${Angle}deg); }  
                100%{ left:${x}px; top:${y}px; width:${width}px; height:${height}px; transform:rotate(${AzAngle}deg); }`;

      var styles = styled.div`
        position: absolute;
        animation: ${AnimationFrames} ${aikVariable}s linear;
        left: ${x}px;
        top: ${y}px;
        width: ${width}px;
        height: ${height}px;
        z-index: ${zInd};
        transform: rotate(${rotation}deg);
      `;
      setAnimationStyle(styles);
    } else {
      let AzAngle;
      if (rotation > 180) {
        AzAngle = rotation - 360;
      } else {
        AzAngle = rotation;
      }

      let Angle;
      if (value.originalRotateAngle > 180) {
        Angle = value.originalRotateAngle - 360;
      } else {
        Angle = value.originalRotateAngle;
      }
      var aikVariable = calculateSecondsByWidth(widthOnTimeline);
      const AnimationFrames = keyframes`0%{ left:${value.originalX}px; top:${value.originalY}px; width:${value.originalWidth}px; height:${value.originalHeight}px; transform:rotate(${Angle}deg); }  
                100%{ left:${x}px; top:${y}px; width:${width}px; height:${height}px; transform:rotate(${AzAngle}deg); }`;

      var styles = styled.div`
        position: absolute;
        animation: ${AnimationFrames} ${aikVariable}s linear;
        left: ${x}px;
        top: ${y}px;
        width: ${width}px;
        height: ${height}px;
        z-index: ${zInd};
        transform: rotate(${rotation}deg);
      `;
      setAnimationStyle(styles);
    }
  };

  const calculateSecondsByWidth = (width) => {
    let ms = parseFloat((width * onePxEquivalent).toFixed(3));
    return msToSeconds(ms);
  };

  const msToSeconds = (duration) => {
    var seconds = (duration / 1000).toFixed(2);
    return seconds;
  };

  useEffect(() => {
    if (StoreData) {
      enterKeyFrame(
        StoreData.AzData.width,
        StoreData.AzData.height,
        StoreData.AzData.y,
        StoreData.AzData.x,
        StoreData.AzData.rotateAngle,
        StoreData.AzData.widthOnTimeline,
        true
      );
    }
  }, [StoreData]);

  useEffect(() => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      let aToZStart =
        array[i].startPositionOnTimeline + array[i].startTransitionWidth;
      if (
        array[i].AzData &&
        Click_TickerPosition >= aToZStart &&
        Click_TickerPosition <= array[i].AzData.widthOnTimeline + aToZStart
      ) {
        let remainingWidthOnTimeline =
          array[i].AzData.widthOnTimeline + aToZStart - Click_TickerPosition;
        enterKeyFrame(
          StoreData.width,
          StoreData.height,
          StoreData.y,
          StoreData.x,
          StoreData.rotateAngle,
          remainingWidthOnTimeline,
          true
        );
      } else if (array[i].AzData && Click_TickerPosition <= aToZStart) {
        enterKeyFrame(
          array[i].AzData.width,
          array[i].AzData.height,
          array[i].AzData.y,
          array[i].AzData.x,
          array[i].AzData.rotateAngle,
          array[i].AzData.widthOnTimeline,
          false
        );
      }
    }
  }, [Click_TickerPosition]);

  useEffect(() => {
    // debugger
    if (LayersData) {
      if (CanvasDisplay) {
        for (let i = 0; i < LayersData.length; i++) {
          if (LayersData[i].key == value.key && LayersData[i].AzData) {
            if (!StoreData) {
              setStoreData(clone(LayersData[i]));
            } else {
              if (
                LayersData[i].AzData.x !== StoreData.AzData.x ||
                LayersData[i].AzData.y !== StoreData.AzData.y ||
                LayersData[i].AzData.width !== StoreData.AzData.width ||
                LayersData[i].AzData.height !== StoreData.AzData.height ||
                LayersData[i].AzData.widthOnTimeline !==
                  StoreData.AzData.widthOnTimeline ||
                LayersData[i].AzData.rotateAngle !==
                  StoreData.AzData.rotateAngle
              ) {
                setStoreData(clone(LayersData[i]));
              } else if (
                LayersData[i].x !== StoreData.x ||
                LayersData[i].y !== StoreData.y ||
                LayersData[i].width !== StoreData.width ||
                LayersData[i].height !== StoreData.height ||
                LayersData[i].widthOnTimeline !== StoreData.widthOnTimeline ||
                LayersData[i].rotateAngle !== StoreData.rotateAngle
              ) {
                setStoreData(clone(LayersData[i]));
              }
            }
            break;
          }
        }
      }
    }
  }, [LayersData]);

  const AtoZ = () => {
    let Array = [];
    var index = LayersData.findIndex((x) => x.key === value.key);
    LayersData[index].FurtherSetting = false;
    LayersData[index].Editable = false;
    LayersData[index].x = LayersData[index].originalX;
    LayersData[index].y = LayersData[index].originalY;
    LayersData[index].width = LayersData[index].originalWidth;
    LayersData[index].height = LayersData[index].originalHeight;
    LayersData[index].rotateAngle = LayersData[index].originalRotateAngle;
    setTickerState(
      LayersData[index].startTransitionWidth +
        LayersData[index].AzData.widthOnTimeline
    );
    Array.push(clone(LayersData[index]));
    Array.push(clone(LayersData[index].AzData));
    setAtoZ(Array);
    setLayersData(LayersData);
  };

  var IsSetStateUpdate = false;
  const Dragger = (e, data) => {
    //console.log("clicked by animated text using Dragger");
    if (data.node.nextSibling) {
      data.node.nextSibling.style.left = data.x + "px";
      data.node.nextSibling.style.top = data.y + "px";
      data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`;
    }

    let change = false;

    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].waitSS = false;
        IsSetStateUpdate = false;

        if (!newArray[i].DrapEndAnimatedText) {
          newArray[i].DrapEndAnimatedText = true;
          change = true;
        }

        if (newArray[i].showDiv) {
          newArray[i].showDiv = false;
          change = true;
        }

        if (newArray[i].Editable) {
          newArray[i].Editable = false;
          change = true;
        }

        if (newArray[i].toolbar) {
          newArray[i].toolbar = false;
          change = true;
        }
      }
    }

    if (change) {
      setLayersData(newArray);
    }
  };

  // change
  const DragEnd = async (e, data) => {
    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].x = (data.x / EditorZoom) * 100;
        newArray[i].y = (data.y / EditorZoom) * 100;
        newArray[i].Editable = true;
        newArray[i].toolbar = true;
        newArray[i].waitSS = true;
        newArray[i].showDiv = true;
        newArray[i].FurtherSetting = true;
        // newArray[i].isTextBox = false;

        if (newArray[i].type == "AnimatedText") {
          if (newArray[i].JSONValue?.fromAssets) {
            newArray[i].JSONValue.assets.map((value) => {
              if (value.layers[0]?.nm.toLowerCase().includes("text"))
                if (value.layers[0]?.t?.d?.k[0]?.s)
                  value.layers[0].t.d.k[0].s.isTextBox = false;
            });
          } else {
            newArray[i].JSONValue?.layers.map((x) => {
              if (x.nm.toLowerCase().includes("text"))
                if (x.t?.d?.k[0]?.s) x.t.d.k[0].s.isTextBox = false;
            });
          }
          newArray[i].DrapEndAnimatedText = true;
        }

        IsSetStateUpdate = false;
      } else {
        newArray[i].Editable = false;
        newArray[i].toolbar = false;
        newArray[i].showDiv = false;

        if (newArray[i].type === "text") {
          newArray[i].edit = "false";
          if (newArray[i].FurtherSetting === true) {
            newArray[i].FurtherSetting = false;
          }
          if (newArray[i].Editable === true) {
            newArray[i].Editable = false;
          }
        }
      }
    }

    // const _slides = Array.form(slides);
    // const active_slides = _slides.find(x => x.IsActive === true);
    // active_slides.LayerData = newArray;

    // if(!Call_ScreenShot)
    // {
    //   setCall_ScreenShot(true)
    // }
    setLayersData(newArray);
  };

  const Activated = () => {
    if (MultiDrag.length > 1) {
      let arr = [];
      setMultiDrag(arr);
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].InMultiDrag) {
          arr.push(array[i]);
        }
        if (array[i].key == value.key) {
          arr.push(array[i]);
          array[i].InMultiDrag = true;
        }
        array[i].showDiv = false;
        array[i].toolbar = false;
        array[i].Editable = false;
      }
      setMultiDrag(arr);
      setLayersData(array);
    } else {
      let arr = [];
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key !== value.key) {
          if (array[i].Editable == true) {
            arr.push(array[i]);
            array[i].Editable = false;
          }
        } else {
          arr.push(array[i]);
        }
      }
      if (arr.length > 1) {
        setMultiDrag(arr);
        for (const itr of array) {
          for (const atr of arr) {
            if (atr.key == itr.key) {
              itr.InMultiDrag = true;
            }
            atr.toolbar = false;
          }
        }
        setLayersData(array);
      } else {
        for (var i = 0; i < array.length; i++) {
          if (array[i].key == value.key) {
            array[i].toolbar = true;
            array[i].Editable = true;
          } else {
            array[i].Editable = false;
          }
        }
        setLayersData(array);
        arr = [];
      }
    }
  };

  const SettingShow = async (e) => {
    //ShowPanelLeft
    seteditableObject({ showPanel: true, editableItem: value });
    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === value.key) {
        array[i].toolbar = false;
        array[i].FurtherSetting = true;
        break;
      }
    }
    setLayersData(array);
  };

  useEffect(() => {
    if (dragref.current) {
      dragref.current.style.transform = `translate(${
        (value.x * EditorZoom) / 100
      }px, ${(value.y * EditorZoom) / 100}px) rotate(${value.rotateAngle}deg)`;
    }
  }, [value.rotateAngle, dragref.current]);

  return (
    <>
      <Draggable
        defaultClassName={Dragging ? "AniamteDrag" : "AniamteDrag dotedBorder"}
        onMouseDown={(e) => {
          if (e.shiftKey) {
            Activated();
            return false;
          }
        }}
        onStart={(e) => {
          if (e.shiftKey) {
            return false;
          }
          setDragging(true);
          SettingShow();
        }}
        onDrag={(event, data) => Dragger(event, data)}
        onStop={(event, data) => {
          DragEnd(event, data);
          setDragging(false);
        }}
        //cancel={".resizable-handler , .square , .rotate"}
        position={{
          x: (value.x * EditorZoom) / 100,
          y: (value.y * EditorZoom) / 100,
        }}
      >
        <div
          id={`Inner-${value.AnimationId}`}
          // onclick={activeEdit}
          ref={dragref}
          style={{
            display: !CanvasDisplay
              ? value.player
                ? "inline-block"
                : "none"
              : value.startPositionOnTimeline <= TickerPosition &&
                value.startPositionOnTimeline + value.widthOnTimeline >=
                  TickerPosition
              ? "inline-block"
              : "none",
            width: (value.width * EditorZoom) / 100,
            height: (value.height * EditorZoom) / 100,
          }}
        />
      </Draggable>
      {/* )}
        </>)} */}

      <div
        id={`Outer-${value.AnimationId}`}
        ref={!value.Editable ? CharRef : resizeRef}
        className={
          "textUppperDiv changer " +
          (value.Editable ? " RectBorder " : "") +
          (!CanvasDisplay ? value.InClass + value.OutClass : "")
        }
        style={{
          border: value.lock == true ? "1px dashed #37484f" : "",
          display: !CanvasDisplay
            ? value.player
              ? "inline-block"
              : "none"
            : value.startPositionOnTimeline <= TickerPosition &&
              value.startPositionOnTimeline + value.widthOnTimeline >=
                TickerPosition
            ? "inline-block"
            : "none",
          width: (value.width * EditorZoom) / 100 + "px",
          height: (value.height * EditorZoom) / 100 + "px",
          VendorAnimationDuration: ".5s",
          zIndex: zInd,
          transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
          left: Math.round((value.x * EditorZoom) / 100),
          top: Math.round((value.y * EditorZoom) / 100),
          // marginTop: "-2%"
        }}
        onClick={() => {
          // setDragging(true)
          if (!value.AzData) {
            if (!value.lock) {
              TextClick(value.key);
            }
          } else {
            AtoZ();
          }
        }}
      >
        <CharacterLoader
          key={`CharacterLoader${index}`}
          index={index}
          value={value}
          height={value.height}
          width={value.width}
          player={value.Animate}
          ticker={TickerPosition}
          Setting={value.character_Setting}
          isAnimatedText={true}
        />

        {value.lock === true && (
          <div
            data_set="lock_object"
            className="LockTop"
            style={{ zIndex: "100" }}
          >
            <div className="LockInnerBorder">
              <span
                className="material-icons material-icons-outlined Lockback"
                onMouseOver={LockShow}
              >
                lock
              </span>
              <span
                className="material-icons material-icons-outlined unlock "
                style={{ cursor: "pointer" }}
                onMouseOut={locked}
                onClick={() => Unlock(value.key)}
              >
                lock_open
              </span>
            </div>
          </div>
        )}
      </div>

      {value.showDiv && (
        <div
          id={`showDiv-${value.AnimationId}`}
          ref={resizeRef2}
          style={{
            VendorAnimationDuration: ".5s",
            cursor: value.lock == true ? "default" : "grab",
            transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
            display: !CanvasDisplay
              ? value.player && !value.startAtoZ
                ? "inline-block"
                : "none"
              : value.startPositionOnTimeline <= TickerPosition &&
                value.startPositionOnTimeline + value.widthOnTimeline >=
                  TickerPosition
              ? "inline-block"
              : "none",
            height: (value.height * EditorZoom) / 100,
            width: (value.width * EditorZoom) / 100,
            zIndex: !value.lock ? 1000 : 1100 + 50,
            border: value.lock == true ? "1px dashed red" : "2px solid #e87ed4",
            left: Math.round((value.x * EditorZoom) / 100),
            top: Math.round((value.y * EditorZoom) / 100),
            position: "absolute",
          }}
        ></div>
      )}
    </>
  );
}

export default AnimatedText;
